import $ from 'jquery'
import {sentryAPIErrorV2} from './module_common';
import {dataContainerSelector} from './module_common_selector';
import Modal from 'bootstrap/js/dist/modal'

// window.modal = Modal

export const signInModalId = $(dataContainerSelector).data("signinmodal")
export const tryPremiumModalId = $(dataContainerSelector).data("trypremiummodal")

export function openModal(selector, functionName){
    const el = $(selector)
    if (el.length == 0){
        const contextData = {
            modalData:{
                function: functionName,
                selector: selector,
                uid: UIDg,
            }
        }
        const error = new Error('Error opening modal')
        error.name = selector+' modal open fail'
        sentryAPIErrorV2(error, contextData)
    }else{
        const m = Modal.getInstance(el[0])
        if (m){
            if (el[0].classList.contains('show')) return
            m.show()
        }else{
            new Modal(el[0]).show()
        }
    }
}

export function openModalWithRef(selector, refElement, functionName){
    const el = $(selector)
    if (el.length == 0){
        const contextData = {
            modalData:{
                function: functionName,
                selector: selector,
                uid: UIDg,
            }
        }
        const error = new Error('Error opening modal')
        error.name = selector+' modal open fail'
        sentryAPIErrorV2(error, contextData)
    }else{
        // set 'reference' element that trigger open in DOM element custom property
        el[0]._customRelatedTarget = refElement
        new Modal(el[0]).show()
    }
}